function slugify(str) {
  return String(str)
    .normalize("NFKD") // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, "") // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, "") // remove non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      if (first) first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      if (last) last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();
    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

function enableSpeculationPrerenderOnHover(selector = '.prerender-link') {
  const prerendered = new Set();
  const prefetched = new Set();
  const supportsSpeculation = HTMLScriptElement.supports?.('speculationrules');

  document.querySelectorAll(selector).forEach((link) => {

    link.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      if (prerendered.has(link.href)) return;

      if (supportsSpeculation) {
        addPrerender(link.href);
      } else {
        addPrefetch(link.href);
      }

      prerendered.add(link.href);
    }, { passive: true });

    link.addEventListener("touchstart", () => {
      if (prefetched.has(link.href)) return;

      if (isMobile()) {
        if (supportsSpeculation) {
          addPrerender(link.href);
        } else {
          addPrefetch(link.href);
        }
      } else if (!supportsSpeculation) {
        addPrefetch(link.href);
      }

      prefetched.add(link.href);
    }, { passive: true });

  });
}

function isMobile() {
  return window.matchMedia("(max-width: 760px)").matches;
}

function addPrerender(url) {
  const rule = { prerender: [{ urls: [url] }] };
  const script = document.createElement('script');
  script.type = 'speculationrules';
  script.textContent = JSON.stringify(rule);
  document.head.appendChild(script);
}

function addPrefetch(url) {
  if (document.querySelector(`link[data-prefetch="${url}"]`)) return;

  const el = document.createElement('link');
  el.rel = 'prefetch';
  el.href = url;
  el.as = 'document';
  el.setAttribute('data-prefetch', url);
  document.head.appendChild(el);
}

enableSpeculationPrerenderOnHover();

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    if (video) video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    if (video) video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  if(summaryElement){
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
    this.cartLimits = document.querySelector("cart-limits");
    this.maxPerVariant = this.cartLimits.maxPerVariant;
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (value > parseInt(this.input.max)) {
      this.input.value = this.maxPerVariant;
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = (this) ? this.querySelector(".quantity__button[name='minus']") : null;
      if(buttonMinus) buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = (this) ? this.querySelector(".quantity__button[name='plus']") : null;
      if(buttonPlus) buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    // console.log("closeMenuDrawer");
    if (event === undefined) return;
    if (
      this.mainDetailsToggle &&
      this.mainDetailsToggle.classList &&
      this.mainDetailsToggle.className.includes("menu-opening")
    ) {
      this.mainDetailsToggle.classList.remove("menu-opening");
    }

    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      if (details) {
        details.removeAttribute("open");

        if (details.classList && details.className.includes("menu-opening")) {
          details.classList.remove("menu-opening");
        }
      }
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      if (submenu) submenu.classList.remove("submenu-open");
    });

    if (
      document.body &&
      document.body.classList &&
      document.body.className.includes(`overflow-hidden-${this.dataset.breakpoint}`)
    ) {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    if (this.header && this.header.classList.contains("menu-open")) this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  };
}
customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const popup = this.querySelector('[id^="ModalClose-"]');
    if(popup) popup.addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    if (this.classList.contains("pause")) {
      this.classList.remove("pause");
      this.querySelectorAll(".js-youtube").forEach((video) => {
        if (video) video.contentWindow.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}', "*");
      });
      return;
    } else {
      this.classList.add("pause");
      this.querySelectorAll(".js-youtube").forEach((video) => {
        if (video) video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
      });
    }
  }
  // loadContent(focus = true) {
  //   window.pauseAllMedia();
  //   if (!this.getAttribute("loaded")) {
  //     const content = document.createElement("div");
  //     const template = this.querySelector("template");
  //     if (template) content.appendChild(template.content.firstElementChild.cloneNode(true));

  //     this.setAttribute("loaded", true);
  //     const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
  //     if (focus) deferredElement.focus();
  //     if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
  //       // force autoplay for safari
  //       deferredElement.play();
  //     }
  //   }
  // }
}
customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.enableLightbox = this.getAttribute("data-enable-lightbox") === "true";
    this.lightbox = null;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.sliderItems || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    if (this.enableLightbox) {
      const listItens = this.querySelectorAll("li.lightbox_item");
      const nameAllVariants = Array.from(listItens).map((item) => item.dataset.mediaAlt);
      const listVariantsFilter = nameAllVariants.filter((item, i) => nameAllVariants.indexOf(item) === i);

      let notClass = "show-mobile";
      if (window.innerWidth < 750) {
        notClass = "show-desktop";
      }
      listVariantsFilter.forEach((element) => {
        let item = `a.lightbox-filter-${element}:not(.${notClass}), a.lightbox-filter-${element}-desktop:not(.${notClass}), a.lightbox-filter-${element}-mobile:not(.${notClass})`;

        if (window.PhotoSwipeLightbox) {
          const lightbox = new window.PhotoSwipeLightbox({
            gallery: ".product__media-list",
            children: item,
            // dynamic import is not supported in UMD version
            pswpModule: window.PhotoSwipe,
            initialZoomLevel: window.innerWidth >= 750 ? "fit" : "fill",
          });

          lightbox.on("change", () => {
            setTimeout(() => {
              this.autoplay();
            }, 100);
          });

          lightbox.on("close", () => {
            var rand = Math.floor(Math.random() * 1000000 + 1);

            const videos = this.querySelectorAll(".js-youtube") ?? this.querySelectorAll(".js-vimeo");
            videos.forEach((video) => {
              const src = video.getAttribute("src");
              if (src.includes("?")) {
                video.setAttribute("src", src + "&rand=" + rand);
              } else {
                video.setAttribute("src", src + "?rand=" + rand);
              }
            });
          });

          lightbox.on("bindEvents", () => {
            setTimeout(() => {
              this.autoplay();
            }, 100);
          });

          lightbox.addFilter("itemData", (itemData) => {
            var idVideo = itemData.element.dataset.idVideo;
            if (idVideo !== undefined) {
              const divVideo = document.getElementById(`${idVideo}`);
              const iframeVideo = divVideo.querySelector(`iframe`) ?? divVideo.querySelector(`video`);
              if (iframeVideo != null) {
                iframeVideo.style.maxWidth = "80%";
                iframeVideo.style.maxHeight = "80%";
                iframeVideo.setAttribute("width", "1920px");
                iframeVideo.setAttribute("height", "1080px");
              }
              return {
                html: divVideo.innerHTML,
              };
            }

            return itemData;
          });

          lightbox.init();
        }
      });
    }
  }

  getWindowWidth() {
    return parseInt(document.getElementsByTagName("html")[0].clientWidth);
  }

  pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
      if (video) video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
      if (video) video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => video.pause());
  }

  autoplay() {
    this.pauseAllMedia();

    const itemCurrent = document.querySelector(`.pswp__item[aria-hidden="false"]`);
    const typeItem = itemCurrent.querySelector(`.pswp__content`);

    if (typeItem) {
      const iframeVideo = typeItem.querySelector(`iframe`) ?? typeItem.querySelector(`video`);
      let url_video = iframeVideo.src.split("?");

      if (url_video[0].includes("youtube") || url_video[0].includes("vimeo")) {
        let url_parameters = url_video[1].split("&");
        let url_parameters_new = url_parameters.map((item) => {
          if (item.includes("autoplay")) {
            return "autoplay=1";
          }
          return item;
        });
        let url_video_new = url_video[0] + "?" + url_parameters_new.join("&");
        iframeVideo.src = url_video_new;
      } else {
        iframeVideo.play();
      }
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  toFirstSlide() {
    const step = Number(this.currentPageElement.textContent) - 1;
    const zeroPosition = this.slider.scrollLeft - step * this.sliderItemOffset;
    setTimeout(() => {
      this.slider.scrollTo({
        left: zeroPosition,
      });
    }, 300);
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}
customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (!this.sliderItemsToShow || this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.reducedMotion.addEventListener("change", () => {
      if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
    });

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector(".announcement-bar-slider").contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    if (!this.sliderItemsToShow) return;

    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define("slideshow-component", SlideshowComponent);

class GlideComponent extends HTMLElement {
  constructor() {
    super();
    this.instanceGlide = null;
    this.glide = null;

    this.boxGlide = this.querySelector("#glide") ?? null;
    this.slidesGlide = this.querySelectorAll(".glide__slide");

    if (!this.boxGlide) return;

    this.type = this.boxGlide.dataset.type ? this.boxGlide.dataset.type : "carrossel";
    this.perView = this.boxGlide.dataset.perview ? parseInt(this.boxGlide.dataset.perview) : 4;
    this.rewind = this.boxGlide.dataset.rewind === "true";
    this.keyboard = this.boxGlide.dataset.keyboard === "true";
    this.swipeThreshold = this.boxGlide.dataset.swipeThreshold ? parseInt(this.boxGlide.dataset.swipeThreshold) : 80;
    this.dragThreshold = this.boxGlide.dataset.dragThreshold ? parseInt(this.boxGlide.dataset.dragThreshold) : 120;
    this.peek = this.boxGlide.dataset.peek === "true";
    this.perViewMobile = this.boxGlide.dataset.perviewmobile ? parseInt(this.boxGlide.dataset.perviewmobile) : 1;
    this.gap = this.boxGlide.dataset.gap ? parseInt(this.boxGlide.dataset.gap) : 20;
    this.autoRotate = this.boxGlide.dataset.auto_rotate === "true";
    this.speed = this.boxGlide.dataset.speed ? this.boxGlide.dataset.speed * 1000 : 0;
    this.buttonScrollDown = this.querySelector(".btn-arrow-down");
    this.justMobile = this.boxGlide.dataset.justmobile === "true";
    this.disableGlide = this.boxGlide.dataset.disable_glide === "true";
    this.mediaQueryActive = this.boxGlide.dataset.media_query_active
      ? parseInt(this.boxGlide.dataset.media_query_active)
      : 750;
    this.peekAfterMobile = this.boxGlide.dataset.peekAfterMobile ? parseInt(this.boxGlide.dataset.peekAfterMobile) : 30;
    this.peekBeforeMobile = this.boxGlide.dataset.peekBeforeMobile
      ? parseInt(this.boxGlide.dataset.peekBeforeMobile)
      : 0;
    this.peekGapMobile = this.boxGlide.dataset.peekGapMobile ? parseInt(this.boxGlide.dataset.peekGapMobile) : 10;
    this.peekAfter = this.boxGlide.dataset.peekAfter ? parseInt(this.boxGlide.dataset.peekAfter) : 100;
    this.peekBefore = this.boxGlide.dataset.peekBefore ? parseInt(this.boxGlide.dataset.peekBefore) : 0;
    this.peekGap = this.boxGlide.dataset.peekGap ? parseInt(this.boxGlide.dataset.peekGap) : 20;

    this.active = false;
    this.resizeHandler = this.glideState.bind(this);
    this.scrollDownHandler = this.scrollDown.bind(this);

    this.init();
  }

  init() {
    if (this.buttonScrollDown) {
      this.buttonScrollDown.addEventListener("click", this.scrollDownHandler);
    }

    if (this.disableGlide && this.justMobile && this.getWindowWidth() > this.mediaQueryActive) {
      this.instanceGlide = null;
      window.addEventListener("resize", this.resizeHandler);
      return;
    }

    if (!this.disableGlide || this.justMobile) {
      this.mountGlide();
    }

    if (this.justMobile) {
      window.addEventListener("resize", this.resizeHandler);
    }
  }

  mountGlide() {
    if (!this.boxGlide || this.active) return;

    const GlideComponent = new Glide(this.boxGlide, this.options()).mount({
      FloatingGuard: this.floatingGuard(),
      Controls: this.safeControls(),
    });

    if (this.hasAttribute("has-pagination")) {
      GlideComponent.on(["mount.after", "run"], function () {
        const paginationCurrent = document.querySelector(".js.glide__pagination .glide__pagination--current");
        if (paginationCurrent) paginationCurrent.innerHTML = GlideComponent.index + 1;
      });
    }

    this.instanceGlide = GlideComponent;
    this.glide = GlideComponent;
    this.active = true;

    this.bindHeroBannerTracking(GlideComponent);
  }

  bindHeroBannerTracking(GlideComponent) {
    if (this.id !== "hero-banner") return;

    var slides = this.querySelectorAll(".glide__slide");
    var swiped = false;

    GlideComponent.on("swipe.end", function () {
      swiped = true;
    });

    GlideComponent.on("run.after", function (move) {
      if (!swiped) return;

      swiped = false;
      var activeSlide = slides[GlideComponent.index];

      window.__tracking?.trackEvent("swipe_hero_banner_carousel", {
        position: GlideComponent.index + 1,
        direction: move.direction === ">" ? "forward" : "backward",
        content: activeSlide ? activeSlide.dataset.slideContent || "" : "",
      });
    });
  }

  safeControls() {
    return function (Glide, Components, Events) {
      var controlsSelector = '[data-glide-el^="controls"]';
      var navSelector = '[data-glide-el="controls[nav]"]';
      var previousSelector = controlsSelector + ' [data-glide-dir*="<"]';
      var nextSelector = controlsSelector + ' [data-glide-dir*=">"]';
      var supportsPointer = typeof window.PointerEvent !== "undefined";
      var clickGuardMs = 500;

      var controls = [];
      var navs = [];
      var lastPointerTime = 0;

      function toArray(list) {
        return Array.prototype.slice.call(list || []);
      }

      function controlChildren() {
        return controls.reduce(function (items, control) {
          return items.concat(toArray(control.children));
        }, []);
      }

      function resetArrowState() {
        var arrows = toArray(Components.Html.root.querySelectorAll(previousSelector)).concat(
          toArray(Components.Html.root.querySelectorAll(nextSelector))
        );

        arrows.forEach(function (arrow) {
          arrow.classList.remove(Glide.settings.classes.arrow.disabled);
        });
      }

      function disableArrows(arrows) {
        toArray(arrows).forEach(function (arrow) {
          arrow.classList.add(Glide.settings.classes.arrow.disabled);
        });
      }

      function setArrowState() {
        if (Glide.settings.rewind) return;

        var previous = Components.Html.root.querySelectorAll(previousSelector);
        var next = Components.Html.root.querySelectorAll(nextSelector);

        resetArrowState();

        if (Glide.index === 0) {
          disableArrows(previous);
        }

        if (Glide.index === Components.Run.length) {
          disableArrows(next);
        }
      }

      function setActive() {
        navs.forEach(function (nav) {
          toArray(nav.children).forEach(function (item, index) {
            item.classList.toggle(Glide.settings.classes.nav.active, index === Glide.index);
          });
        });
      }

      function run(event) {
        var now = performance.now();

        if (event.type === "click" && now - lastPointerTime < clickGuardMs) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (event.type === "pointerup") {
          lastPointerTime = now;
        }

        var direction = event.currentTarget.getAttribute("data-glide-dir");
        if (!direction || Glide.disabled) return;

        event.preventDefault();
        Components.Run.make(Components.Direction.resolve(direction));
      }

      function bind() {
        controls = toArray(Components.Html.root.querySelectorAll(controlsSelector));
        navs = toArray(Components.Html.root.querySelectorAll(navSelector));

        controlChildren().forEach(function (control) {
          if (supportsPointer) {
            control.addEventListener("pointerup", run);
            control.addEventListener("click", run);
          } else {
            control.addEventListener("click", run);
          }
        });
      }

      function unbind() {
        controlChildren().forEach(function (control) {
          control.removeEventListener("pointerup", run);
          control.removeEventListener("click", run);
        });
      }

      Events.on(["mount.after", "move.after"], function () {
        setActive();
      });

      Events.on(["mount.after", "run"], function () {
        setArrowState();
      });

      Events.on("destroy", function () {
        unbind();
      });

      return {
        mount: bind,
        setActive: setActive,
        setArrowState: setArrowState,
        removeBindings: unbind,
        items: controls,
      };
    };
  }

  floatingGuard() {
    return function (Glide, Components, Events) {
      return {
        mount() {
          Events.on("run.before", () => {
            Glide.selector.classList.remove("glide--legal-text-active");
          });
        },
      };
    };
  }

  destroy() {
    if (this.instanceGlide) {
      this.instanceGlide.destroy();
      this.instanceGlide = null;
      this.glide = null;
      this.active = false;
    }

    if (this.buttonScrollDown) {
      this.buttonScrollDown.removeEventListener("click", this.scrollDownHandler);
    }

    window.removeEventListener("resize", this.resizeHandler);
  }

  getWindowWidth() {
    return parseInt(document.getElementsByTagName("html")[0].clientWidth);
  }

  glideState() {
    if (this.getWindowWidth() < this.mediaQueryActive && this.justMobile) {
      if (!this.active && this.boxGlide) {
        this.mountGlide();
      }
    }

    if (this.getWindowWidth() > this.mediaQueryActive && this.disableGlide) {
      if (this.active && this.instanceGlide) {
        this.instanceGlide.destroy();
        this.instanceGlide = null;
        this.glide = null;
        this.active = false;
      }
    }
  }

  glideSetControlls() {
    const containerControlls = this.querySelector(".glide__bullets");
    this.slidesGlide = this.querySelectorAll(".glide__slide");

    if (containerControlls) {
      for (let i = 0; i < this.slidesGlide.length; i++) {
        containerControlls.innerHTML += `<button class="glide__bullet" data-glide-dir="=${i}"></button>`;
      }
    }
  }

  glideEnable() {
    this.disableGlide = false;
  }

  update() {
    if (this.instanceGlide) {
      this.instanceGlide.update(this.options());
    }
  }

  scrollDown() {
    if (this.boxGlide) {
      var topPos = this.boxGlide.scrollHeight;
      window.scrollTo({ top: topPos, behavior: "smooth" });
    }
  }

  options() {
    let options = {};

    if (this.type == "carrossel") {
      options = {
        animationDuration: 200,
        gap: this.gap,
        breakpoints: {
          990: {
            perView: this.perViewMobile,
          },
        },
      };
    } else {
      let gap_value = this.peek ? 20 : 0;

      options = {
        autoplay: this.autoRotate ? this.speed : this.autoRotate,
        gap: gap_value,
        breakpoints: {
          990: {
            gap: 10,
          },
        },
      };
    }

    let peek = {};
    if (this.peek) {
      peek = {
        peek: {
          gap: this.peekGap,
          after: this.peekAfter,
          before: this.peekBefore,
        },
        breakpoints: {
          990: {
            gap: this.peekGapMobile,
            perView: this.perViewMobile,
            peek: {
              after: this.peekAfterMobile,
              before: this.peekBeforeMobile,
            },
          },
        },
      };
    }

    return {
      ...options,
      ...peek,
      bound: true,
      rewind: this.rewind,
      keyboard: this.keyboard,
      perView: this.perView,
      swipeThreshold: this.swipeThreshold,
      dragThreshold: this.dragThreshold,
    };
  }

  disable() {
    if (this.instanceGlide) {
      this.instanceGlide.disable();
    }
  }

  enable() {
    if (this.instanceGlide) {
      this.instanceGlide.enable();
    }
  }

  currentIndex() {
    return this.instanceGlide ? this.instanceGlide.index : 0;
  }

  goNext() {
    if (this.instanceGlide) {
      this.instanceGlide.go(">");
    }
  }

  goPrev() {
    if (this.instanceGlide) {
      this.instanceGlide.go("<");
    }
  }
}

customElements.define("glide-component", GlideComponent);

// Product Card
customElements.define(
  "gallery-product-card",
  class extends HTMLElement {
    constructor() {
      super();

      this.img = this.querySelector("img");
      if (!this.img) {
        console.error("No image found in gallery-product-card");
        return;
      };
      this.currentMediaId = this.img.getAttribute("data-id");
      this.currentColor = this.querySelector("img").getAttribute("data-variant");
      this.productData = JSON.parse(this.getAttribute("data-product"));

      this.productGender = this.getAttribute("data-gender") ?? null;
      this.productFilters = this.getAttribute("data-filters") ?? null;
      this.imgWrapper = this.querySelector(".gallery-product-card__img-wrapper");

      this.controlButtons = this.querySelectorAll(".gallery-product-card__controls button");
      this.controlButtons.forEach((button) => {
        button.addEventListener("click", this.handleImageNavigation.bind(this));
      });
      this.mediaByColor = {}; 
    } 

    handleImageNavigation(event) {
      event.preventDefault();
      const button = event.currentTarget;
      if (!this.mediaByColor[this.currentColor]) {
        this.mediaByColor[this.currentColor] = this.productData.media.filter((media) => {
          let media_alt = media.alt ? media.alt.replace("|", "-") : media.alt;
          return slugify(media_alt) === this.currentColor && media.media_type === "image";
        });
      }
      const selectedColorMedia = this.mediaByColor[this.currentColor];

      let currentIndex = 0;
      for (let i = 0; i < selectedColorMedia.length; i++) {
        const media = selectedColorMedia[i];
        if (media.id === this.currentMediaId) {
          currentIndex = i;
          break;
        }
      }
      let nextIndex = 0;
      if (button.className.includes("gallery-product-card__next")) {
        nextIndex = currentIndex + 1 < selectedColorMedia.length ? currentIndex + 1 : 0;
      } else {
        nextIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : selectedColorMedia.length - 1;
      }
      const nextMedia = selectedColorMedia[nextIndex];
      if (nextMedia) this.changeImage(nextMedia.src, slugify(nextMedia.alt.replace("|", "-")), nextMedia.id);
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2).replace(".", ",");
      return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(",")[0]}`;
    }

    handleVariantChange(variant, color, productData = null) {
      let imageUrl;
      let colorSlug = color;

      if (this.productGender && this.productGender === "unissex" && this.productFilters) {
        if (this.productFilters.includes("homem")) {
          colorSlug += "-homem";
        }
        if (this.productFilters.includes("mulher")) {
          colorSlug += "-mulher";
        }

        if (productData) {
          imageUrl = productData.media.find((media) => {
            if (media.alt) return slugify(media.alt.replace("|", "-")) === colorSlug;
          });
        }
      }
      if (!imageUrl) {
        imageUrl = variant.featured_image;
        colorSlug = color;
      }
      this.currentColor = colorSlug;
      this.changeImage(imageUrl.src, colorSlug, variant.featured_image.id);
    }

    changeImage(imageUrl, imageAlt, imageId) {
      const newImage = document.createElement("img");
      newImage.setAttribute("src", imageUrl);
      newImage.setAttribute("alt", imageAlt);
      newImage.setAttribute("data-id", imageId);
      newImage.setAttribute("data-media-alt", imageAlt);

      this.imgWrapper.appendChild(newImage);
      this.currentMediaId = imageId;

      setTimeout(() => {
        this.clearImages();
      }, 1000);
    }

    clearImages() {
      this.querySelectorAll("img").forEach((img) => {
        if (img.getAttribute("data-id") && img.getAttribute("data-id") != this.currentMediaId) {
          img.remove();
        }
      });
    }
  }
);

function updateKitUpsellPriceNormalizeFromVariant(variantPriceCents, variantCompareAtPriceCents) {
  const upsellRoot = document.querySelector("cupom-kits-upsell");
  if (!upsellRoot) return;

  const safePrice = Number(variantPriceCents);
  const safeCompare = Number.isFinite(Number(variantCompareAtPriceCents)) && Number(variantCompareAtPriceCents) > 0
    ? Number(variantCompareAtPriceCents)
    : safePrice;

  if (!Number.isFinite(safePrice) || safePrice <= 0) return;

  const timestamp = `global:kit-upsell:update-${new Date().toISOString()}`;

  // Pick the price-normalize that actually represents the current PDP product.
  // The PDP renders with placements `pdp-desk` and `pdp-mob` (see sections/main-product.liquid),
  // not `pdp`. Falling back to a recommendation `card` would wipe the coupon info from the
  // upsell buttons because the card belongs to a different product.
  const mainPNCandidates = Array.from(
    document.querySelectorAll(
      "price-normalize[data-placement='pdp-desk'], price-normalize[data-placement='pdp-mob'], price-normalize[data-placement='pdk']"
    )
  );
  const productId = upsellRoot.getAttribute("data-upsell-kits-product-id");
  const mainPN =
    mainPNCandidates.find((el) => el.getAttribute("data-product-id") === productId) ||
    mainPNCandidates[0] ||
    null;

  const pdkPriceNormalize = document.querySelector("price-normalize[data-placement='pdk']");
  const currentPdkKitDiscount = Number(pdkPriceNormalize?.getAttribute("data-kit-discount") || 0);
  const safeCurrentPdkKitDiscount = Number.isFinite(currentPdkKitDiscount) ? currentPdkKitDiscount : 0;

  upsellRoot.querySelectorAll('a.upsell-kits__button[data-quantity]').forEach((btn) => {
    const pn = btn.querySelector('price-normalize[data-placement="kit-upsell"]');
    if (!pn) return;

    const hasExplicitKitDiscount = btn.hasAttribute("data-upsell-kits-discount");
    const rawKitDiscount = hasExplicitKitDiscount
      ? Number(btn.dataset.upsellKitsDiscount || 0)
      : Number(pn.getAttribute("data-kit-discount") || 0);
    const isUnitButton = btn.dataset.unitButton === "true";
    const isActiveButton = btn.classList.contains("is-active");
    const kitDiscount = (!isUnitButton && isActiveButton && safeCurrentPdkKitDiscount > 0)
      ? safeCurrentPdkKitDiscount
      : rawKitDiscount;

    // Preserve coupon state already resolved by Liquid/price-normalize during
    // the first render. On initial load the main PDP price-normalize may still
    // not be initialized, which caused this updater to overwrite the upsell
    // prices with a non-coupon state a few milliseconds later.
    const existingDiscountCode =
      pn.getAttribute("data-default-discount-code") || "";

    const existingShowCoupon =
      pn.getAttribute("data-is-to-show-coupon-discount") || "false";

    const defaultDiscountCode =
      btn.dataset.upsellKitsCouponCode ||
      existingDiscountCode ||
      mainPN?.getAttribute("data-price-object-discount-code") ||
      mainPN?.getAttribute("data-default-discount-code") ||
      "";

    const isToShowCoupon =
      existingShowCoupon !== "false"
        ? existingShowCoupon
        : mainPN?.getAttribute("data-is-to-show-coupon-discount") || "false";

    btn.dataset.upsellPrice = String(safePrice);
    btn.dataset.upsellBasePrice = String(safePrice);
    btn.dataset.upsellCompareAtPrice = String(safeCompare);

    const hasKitCoupon = Number(btn.dataset.upsellKitsCoupon || 0) > 0;

    if (hasKitCoupon && defaultDiscountCode) {
      pn.setAttribute("data-default-discount-code", defaultDiscountCode);
      // When the button itself has a coupon, force the discount display ON,
      // even if the main PN currently reports "false" (e.g. its init hasn't finished yet).
      pn.setAttribute("data-is-to-show-coupon-discount", "true");
    } else if (kitDiscount > 0) {
      // Keep previous behavior for generic coupons: kit discount should not stack
      // unless the button carries its own coupon from metafield.
      pn.removeAttribute("data-default-discount-code");
      pn.setAttribute("data-is-to-show-coupon-discount", "false");
    } else if (defaultDiscountCode) {
      // No button-specific coupon, but a discount code exists from another
      // source (promotionCoupon system, main PN). Preserve it so
      // price-normalize can apply the coupon discount.
      pn.setAttribute("data-default-discount-code", defaultDiscountCode);
      pn.setAttribute("data-is-to-show-coupon-discount", isToShowCoupon);
    } else {
      pn.removeAttribute("data-default-discount-code");
      pn.setAttribute("data-is-to-show-coupon-discount", isToShowCoupon);
    }

    pn.setAttribute("data-pristine-price", String(safePrice));
    pn.setAttribute("data-min-price", String(safePrice));
    pn.setAttribute("data-compare-at-price", String(safeCompare));
    pn.setAttribute("data-kit-discount", String(kitDiscount));
    pn.setAttribute("data-timestamp", timestamp);
  });
}

// Init kit-upsell button prices on first page load.
// Without this, the placeholders stay empty until the first variant change triggers an update.
function initKitUpsellPricesOnLoad() {
  const upsellRoot = document.querySelector("cupom-kits-upsell");
  if (!upsellRoot) return;

  // Liquid provides the currently selected (or first available) variant price in cents.
  const initialVariantPriceCents = Number(upsellRoot.getAttribute("data-upsell-loaded-variant"));

  // Fallback: use product max price if needed.
  const fallbackPriceCents = Number(upsellRoot.getAttribute("data-upsell-kits-product-price"));

  const priceCentsToUse =
    Number.isFinite(initialVariantPriceCents) && initialVariantPriceCents > 0
      ? initialVariantPriceCents
      : Number.isFinite(fallbackPriceCents) && fallbackPriceCents > 0
        ? fallbackPriceCents
        : NaN;

  if (!Number.isFinite(priceCentsToUse) || priceCentsToUse <= 0) return;

  const firstPriceNormalize = upsellRoot.querySelector('a.upsell-kits__button price-normalize[data-placement="kit-upsell"]');
  const initialCompareAtPriceCents = Number(firstPriceNormalize?.getAttribute("data-compare-at-price") || 0);

  updateKitUpsellPriceNormalizeFromVariant(priceCentsToUse, initialCompareAtPriceCents);
}

// Run once on initial load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initKitUpsellPricesOnLoad);
} else {
  initKitUpsellPricesOnLoad();
}

// Also re-run when Shopify sections are dynamically loaded/updated (theme editor, AJAX swaps)
document.addEventListener("shopify:section:load", initKitUpsellPricesOnLoad);
customElements.define(
  "product-card-color-selector",
  class extends HTMLElement {
    constructor() {
      super();

      this.currentColor = null;

      this.colorSwatchs = this.querySelectorAll("button.color-swatch");
      this.colorSwatchs.forEach((swatch) => {
        swatch.addEventListener("click", this.handleColorClick.bind(this));
        if (swatch.className.includes("color-swatch--selected")) {
          this.currentColor = swatch.getAttribute("data-color");
        }
      });

      this.scrollWrapper = this.querySelector(".product-card-color-selector__buttons__wrapper");
      this.scrollButtonPrev = this.querySelector(".product-card-color-selector__scroll-btn--prev");
      if (this.scrollButtonPrev) {
        this.scrollButtonPrev.addEventListener("click", this.handleScrollClick.bind(this));
      }
      this.scrollButtonNext = this.querySelector(".product-card-color-selector__scroll-btn--next");
      if (this.scrollButtonNext) {
        this.scrollButtonNext.addEventListener("click", this.handleScrollClick.bind(this));
      }

      this.productCard = this.closest(".card-wrapper");
      this.productGallery = this.productCard.querySelector("gallery-product-card");
      this.productLinks = this.productCard.querySelectorAll("a.card-link");

      // Handle price groups
      this.havePriceGroups = this.dataset.havePriceGroups === "true" ?? false;
      if (this.havePriceGroups) {
        this.productHandle = this.dataset.productHandle ?? null;
        this.initGroupPrices()
      }
      
      this.CupomKitUpsell = this.productCard.querySelector("cupom-kits-upsell");
      this.initPrice();

      this.selectedColorName = this.querySelector(".selected-color span");

      this.glide = this.closest("glide-component");
      this.scrollDragging = false;
      if (this.scrollWrapper) this.initScroll();
    }

    /* Start price group handling */
    initGroupPrices() {
      try {
        const productHandle = this.productHandle
        // check if price group cookies are set
        const priceGroupCookie = this.getPriceGroupCookie(productHandle);
        
        if (priceGroupCookie === "loading" || !priceGroupCookie) return this.setupPriceGroupListeners();

        this.priceAdjustment = priceGroupCookie.priceAdjustment
        this.markdownAdjustment = priceGroupCookie.markdownAdjustment
      }
      catch (e) {
        console.error(">>>", e)
        this.priceAdjustment = 0;
        this.markdownAdjustment = 0;
      }
    }

    setupPriceGroupListeners() {
      document.addEventListener(`${this.productHandle}-price-group-loaded`, ({ detail }) => {
        this.priceAdjustment = detail.priceAdjustment;
        this.markdownAdjustment = detail.markdownAdjustment;
      });
    }

    getPriceGroupCookie(productHandle) {
      const cookieName = `statsig-group-${productHandle}`;
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
  
      if (cookieValue === "loading") return "loading";
      if (!cookieValue) return null;
      return JSON.parse(cookieValue);
    }
    /* End price group handling */

    initPrice() {
      if (this.productGallery && this.productGallery.productData) {
        if (!this.querySelector(".color-swatch--selected")) return;

        const currentVariantId = this.querySelector(".color-swatch--selected").getAttribute("data-variant");
        if (!currentVariantId) return;

        const variant = this.productGallery.productData.variants.find((variant) => {
          return variant.id === parseInt(currentVariantId);
        });
        this.updatePrice(variant);
      } else {
        setTimeout(this.initPrice, 500);
      }
    }

    initScroll() {
      // get window width
      const productCard = this.closest(".card-wrapper");

      const finalyInit = () => {
        // Listen to scroll on scrollWrapper
        this.scrollWrapper.addEventListener("scroll", this.updateScrollButtons.bind(this));
        this.scrollWrapper.addEventListener("touchmove", this.handleTouchMove.bind(this));
        this.scrollWrapper.addEventListener("touchend", this.handleTouchEnd.bind(this));

        // Update scroll button on init
        this.updateScrollButtons();
        // this.setupDragScroll();

        if (window.innerWidth >= 750) {
          productCard.removeEventListener("mouseover", finalyInit);
          this.setupDragScroll();
        }
      };

      if (window.innerWidth < 750) {
        finalyInit();
      } else {
        productCard.addEventListener("mouseover", finalyInit);
      }
    }

    setupDragScroll() {
      const thisElement = this;
      const ele = this.scrollWrapper;
      let pos = { top: 0, left: 0, x: 0, y: 0 };

      const mouseDownHandler = function (e) {
        if (thisElement.glide) thisElement.glide.disable();
        ele.style.userSelect = "none";

        pos = {
          // The current scroll
          left: ele.scrollLeft,
          // Get the current mouse position
          x: e.clientX,
        };

        document.addEventListener("mousemove", mouseMoveHandler);
        document.addEventListener("mouseup", mouseUpHandler);
      };

      const mouseMoveHandler = function (e) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        if (dx > 3 || dx < -3) thisElement.scrollDragging = true;

        // Scroll the element
        ele.scrollLeft = pos.left - dx;
      };

      const mouseUpHandler = function () {
        if (thisElement.glide) thisElement.glide.enable();

        ele.style.removeProperty("user-select");

        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);

        setTimeout(() => {
          thisElement.scrollDragging = false;
        }, 500);
      };

      // Attach the handler
      ele.addEventListener("mousedown", mouseDownHandler);
    }

    handleTouchMove(event) {
      if (this.glide) this.glide.disable();
    }

    handleTouchEnd(event) {
      if (this.glide) this.glide.enable();
    }

    updateScrollButtons() {
      const scrollWrapperWidth = this.scrollWrapper.clientWidth;
      const scrollWrapperScrollWidth = this.scrollWrapper.scrollWidth;
      const scrollWrapperScrollLeft = this.scrollWrapper.scrollLeft;

      if (scrollWrapperScrollWidth > scrollWrapperWidth) {
        this.scrollWrapper.style.paddingRight = "40%";
        this.scrollButtonPrev.style.display = "none";
        this.scrollButtonNext.style.display =
          scrollWrapperScrollLeft + scrollWrapperWidth < scrollWrapperScrollWidth - 10 ? "block" : "none";
      } else {
        this.scrollButtonPrev.style.display = "none";
        this.scrollButtonNext.style.display = "none";
      }
    }

    handleScrollClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const scrollDirection = button.className.includes("next") ? "next" : "prev";

      if (scrollDirection === "next") {
        const scrollValue = this.scrollWrapper.scrollLeft + 58;
        // scroll with animation
        this.scrollWrapper.scrollTo({
          left: scrollValue,
          behavior: "smooth",
        });
      } else {
        const scrollValue = this.scrollWrapper.scrollLeft - 58;
        // scroll with animation
        this.scrollWrapper.scrollTo({
          left: scrollValue,
          behavior: "smooth",
        });
      }

      this.updateScrollButtons();
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2).replace(".", ",");
      return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(",")[0]}`;
    }

    updatePrice(variant) {
      const variantPrice = this.priceAdjustment ? variant.price + this.priceAdjustment : variant.price;
      const rawCompareAt = Number.isFinite(Number(variant.compare_at_price)) ? variant.compare_at_price : 0;
      const variantCompareAtPrice = this.markdownAdjustment ? rawCompareAt + this.markdownAdjustment : rawCompareAt;

      Array.from(this.productCard.querySelectorAll("price-normalize[data-pristine-price]")).forEach((priceNormalize) => {
        priceNormalize.dataset.pristinePrice = variantPrice;
        priceNormalize.dataset.compareAtPrice = variantCompareAtPrice;
        priceNormalize.dataset.timestamp = `global:productCardColorSelector:updatePrice-${new Date().toISOString()}`;
      })

      // Sync kit-upsell price-normalize instances for the selected variant
      updateKitUpsellPriceNormalizeFromVariant(variantPrice, variantCompareAtPrice);
    }

    handleVariantChange(variantId, color) {
      const productData = this.productGallery.productData;

      for (let i = 0; i < productData.variants.length; i++) {
        const variant = productData.variants[i];
        if (variant.id == variantId) {
          // Update gallery
          this.productGallery.handleVariantChange(variant, color, productData);

          // Update price
          this.updatePrice(variant);
          break;
        }
      }
    }

    handleColorClick(event) {
      event.preventDefault();
      if (this.scrollDragging) return;

      const button = event.currentTarget;
      const color = button.getAttribute("data-color");
      this.currentColor = color;
      const colorName = button.getAttribute("data-color-name");
      const variantId = button.getAttribute("data-variant");
      const variantUrl = button.getAttribute("data-variant-url");

      if (this.productGallery) {
        this.handleVariantChange(variantId, color);
      }

      // Select button and deselect others
      this.colorSwatchs.forEach((swatch) => {
        swatch.classList.remove("color-swatch--selected");
      });
      button.classList.add("color-swatch--selected");

      // Scroll to selected button
      const scrollValue = button.offsetLeft - 29;
      // scroll with animation
      this.scrollWrapper.scrollTo({
        left: scrollValue,
        behavior: "smooth",
      });

      if (this.selectedColorName) this.selectedColorName.textContent = colorName;
      this.productLinks.forEach((link) => {
        link.setAttribute("href", variantUrl);
      });

      this.dispatchEvent(
        new CustomEvent("colorChanged", {
          detail: {
            color: color,
          },
        })
      );
    }
  }
);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.CupomKitUpsell = null;
    this.showImageByAlt = this.getAttribute("data-image-show-by-alt") === "true";
    this.variantsCart = this.getAttribute("variants-cart") == "true" ? true : false;

    this.addEventListener("change", this.onVariantChange);
  }

  getCupomKitUpsell() {
    if (!this.CupomKitUpsell) {
      this.CupomKitUpsell = document.querySelector("cupom-kits-upsell");
    }
    return this.CupomKitUpsell;
  }
  
  async onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    await this.updatePreOrderInfos();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      //this.setUnavailable();
    } else {
      if (!this.variantsCart) {
        this.updateURL();
        this.updateShareUrl();
      }
      this.updateModel();
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
    // Sync kit-upsell price-normalize instances for the selected variant (PDP selects)
    if (this.currentVariant) {
      updateKitUpsellPriceNormalizeFromVariant(this.currentVariant.price, this.currentVariant.compare_at_price);
    }

    // Scope immediate-shipping visibility to the current product section only
    const productScope = this.closest("product-info") || this;
    const immediateShippingElements = productScope.querySelectorAll(".immediate-shipping-info");

    const isAvailable = this.currentVariant?.available;
    const allowsBackorder = this.currentVariant?.inventory_policy === "continue";
    const isSellingPlan = Array.isArray(this.currentVariant?.selling_plan_allocations) && this.currentVariant.selling_plan_allocations.length > 0;

    immediateShippingElements.forEach((element) => {
      if (!isAvailable || allowsBackorder || isSellingPlan) {
        element.classList.add("hidden");
      } else {
        element.classList.remove("hidden");
      }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (this.currentVariant) {
      try {
        // const cupomCountdown = this.getCupomCountdown();
        const CupomKitUpsell = this.getCupomKitUpsell();
        // if (cupomCountdown) cupomCountdown.init();
        if (CupomKitUpsell) CupomKitUpsell.init();
      } catch (error) {
        // console.log(error);
      }
    } else {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }
  }

  updateMedia() {
    if (this.dataset.variantsCart) return;
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const sizeOptions = ["p", "pp", "m", "g", "gg", "xg", "xxg", "xxxg", "xgg", "xxgg", "xxxgg", "embalagem"];
    let variantOptions = "";
    if (this.showImageByAlt) {
      for (let i = 0; i < this.currentVariant.options.length; i++) {
        // slugify option name
        var optionName = slugify(this.currentVariant.options[i]);
        if (sizeOptions.includes(optionName)) continue;
        variantOptions += variantOptions != "" ? `-${optionName}` : optionName;
      }
    }
    if (document.querySelectorAll(`li[data-media-alt='${variantOptions}']`).length == 0) {
      variantOptions = `${slugify(this.currentVariant.options[0])}`;
    }

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      if (typeof mediaGallery.setActiveMedia === "function")
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

      if (typeof mediaGallery.elements.viewer.toFirstSlide === "function") mediaGallery.elements.viewer.toFirstSlide();

      if (this.showImageByAlt) {
        const mediaGallerySlides = mediaGallery.querySelectorAll(".product__media-item");

        this.collection = mediaGallery.dataset.genderCollection ?? null;
        if (this.collection) {
          const variantOptionsCollection = variantOptions + "-" + this.collection;

          const imagesGallery = Object.keys(mediaGallerySlides).map((key) => mediaGallerySlides[key]);
          const ifImagesCollection = imagesGallery.find((slide) => {
            const slideAlt = slide.getAttribute("data-media-alt");
            return variantOptionsCollection == slideAlt;
          });

          variantOptions = ifImagesCollection ? variantOptionsCollection : variantOptions;
        }
        let genderProduct = document.querySelector(`media-gallery`).getAttribute("data-gender-Product");

        mediaGallerySlides.forEach((slide) => {
          let slideAlt = slide.getAttribute("data-media-alt");

          if (genderProduct == "unissex" && !this.collection) {
            slideAlt = slideAlt.replace("-homem", "").replace("-mulher", "");
          }

          if (variantOptions == slideAlt) {
            slide.style.display = "block";
          } else {
            slide.style.display = "none";
          }
        });
      }
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
    
  updateModel() {
    const allModelInfos = document.querySelectorAll( `.product__model`);
      allModelInfos.forEach((model) => {
        if (model.getAttribute("data-variant-id") == this.currentVariant.id) {
          model.style.display = "block";
        } else {
          model.style.display = "none";
        }
      }
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  } 

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    //verifica se a opção 2 (Tamanho) está disponível
    //se não estiver, pega a primeira opção disponível dentro do selectedOptionOneVariants
    //que possui todas as opções referente a opção 1 (Cor) selecionada
    //atualizar o currentVariant usando o metodo updateMasterId
    if (this.options[1] == undefined) {
      this.options[1] = selectedOptionOneVariants[0].option2;
      this.updateMasterId();
    }
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index > 0) {
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        let previousOptionSelected = inputWrappers[index - 1].querySelector(":checked")?.value;
        let sizeSelected = true;
        if (previousOptionSelected == undefined) {
          let variableSelected = selectedOptionOneVariants.find((variant) => variant.available);
          if (variableSelected == undefined) variableSelected = selectedOptionOneVariants[0];
          previousOptionSelected = variableSelected[`option${index}`];
          sizeSelected = false;
        }

        const existingOptionsInputsValue = selectedOptionOneVariants.map(
          (variantOption) => variantOption[`option${index + 1}`]
        );
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`]);

        let elementCheck = inputWrappers[index].querySelector(":checked");
        //verifica se contem a opção 2 (Tamanho) selecionada
        //caso não tenha, pega a primeira opção com estoque disponível (availableOptionInputsValue),
        //caso não possua obtem a primeira dentro do selectedOptionOneVariants
        if (!elementCheck && index == 1) {
          elementCheck = Array.from(inputWrappers[index].querySelectorAll(`input`)).find((item) => {
            if (availableOptionInputsValue && availableOptionInputsValue.length > 0) {
              return item.value == availableOptionInputsValue[0];
            } else {
              return item.value == selectedOptionOneVariants[0].option2;
            }
          });
        }
        if (availableOptionInputsValue.length == 1 && selectedOptionOneVariants.length == 1)
          elementCheck.checked = true;

        this.setInputAvailability(optionInputs, availableOptionInputsValue, existingOptionsInputsValue, sizeSelected);
        //verifica se a opção selecionada está com estoque disponível e ativa o botão de adicionar ao carrinho
        //caso contrário, desativa o botão
        if (elementCheck.classList.contains("disabled")) {
          this.toggleAddButton(true, "", false);
        } else {
          this.toggleAddButton(false, "", false);
        }
      } else {
        // const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        // const option2SelectedInput = this.querySelector("input[data-position='2']:checked");
        // const option2Selected = option2SelectedInput ? option2SelectedInput.value : null;
        // const option3SelectedInput = this.querySelector("input[data-position='3']:checked");
        // const option3Selected = option3SelectedInput ? option3SelectedInput.value : null;
        // const selectedOptionNotOneVariants = this.variantData.filter(
        //   (variant) =>
        //     (!option2Selected || option2Selected === variant.option2) &&
        //     (!option3Selected || option3Selected === variant.option3)
        // );
        // const availableOptionInputsValue = selectedOptionNotOneVariants
        //   .filter((variant) => variant.available)
        //   .map((variantOption) => variantOption[`option${index + 1}`]);
        // this.setInputAvailability(optionInputs, availableOptionInputsValue, null);
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions, listOfExistingOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      if (typeof pickUpAvailability.fetchAvailability === "function")
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
 
 preOrderAbortControllerForListeners;
 
 async updatePreOrderInfos() {
  const root = this.closest("product-info") || this;
  if (!this.currentVariant) return;

  const hasSellingPlan = this.currentVariant.selling_plan_allocations?.length > 0 && this.currentVariant.selling_plan_allocations[0]?.selling_plan_id;
  const preOrderPrazo = this.currentVariant.selling_plan_allocations?.[0]?.selling_plan?.name?.replace("Compra antecipada: envio a partir de ", "");
  const preOrderValue = this.currentVariant.selling_plan_allocations?.[0]?.selling_plan?.description;
  const hasPreOrder = Boolean(hasSellingPlan);

  const buttonsWrapper =
    root.querySelector(".product-form__buttons") ||
    root.querySelector(".product-form__buttons-wrapper");

  await this.clearPreOrderInfos(root, hasPreOrder);

  if (!hasPreOrder) return;
  if (this.currentVariant.selling_plan_allocations[0]?.app_id === 'timesact') return;

  const productForm = document.getElementById(`product-form-${this.dataset.section}`);
  const addButton = productForm ? productForm.querySelector('[name="add"]') : null;

  if (addButton && !root.querySelector(".pre-order-message")) {
    addButton.classList.add('pre-order-add-button');
    addButton.textContent = 'Antecipar Compra';

    const msg = document.createElement("span");
    msg.className = "pre-order-message";
    msg.textContent = "Compra Antecipada";

    const link = document.createElement("a");
    link.className = "pre-order-how-works";
    link.href = "#";
    link.textContent = "Como funciona?";

    link.addEventListener("click", (event) => {
      event.preventDefault();
     if(!window.BackorderDialogs) {
        // Fallback para não travar venda em caso de problemas com os modais
        console.error("BackorderDialogs não encontrado - openHowWorks");
        return;
      }
      window.BackorderDialogs.openHowWorks();
    });

    const wrapper = document.createElement("div");
    wrapper.className = "pre-order-message-wrapper";
    wrapper.appendChild(msg);
    wrapper.appendChild(link);

    addButton.parentElement?.insertBefore(wrapper, addButton);
    this.preOrderAbortControllerForListeners = new AbortController(); // Precisa ser re-instanciado sempre que for CA para que o sinal abortado não permaneça
    productForm.addEventListener('formdata', (event) => {
        const formData = event.formData;
        formData.append('properties[_Esse produto será despachado a partir de]', preOrderPrazo);
        const sellingPlanId = this.currentVariant.selling_plan_allocations[0]?.selling_plan_id;
        if (sellingPlanId) {
          formData.append('selling_plan', Number(sellingPlanId));
        }
        formData.append('properties[__backorder_app]', this.currentVariant.selling_plan_allocations[0]?.app_id);
    },{
      signal: this.preOrderAbortControllerForListeners.signal
    }); 

    addButton.type = "button";
    addButton.addEventListener("click", (event) => {
      event.preventDefault();
      if(!window.BackorderDialogs) {
        // Fallback para não travar venda em caso de problemas com os modais
        console.error("BackorderDialogs não encontrado - BuyButton");
        productForm.dispatchEvent(new Event("submit"));
        return;
      }

      const deliveryText = String(preOrderValue ? preOrderValue : preOrderPrazo);

      const selectedColor = root.querySelector('input[type="radio"][data-name="Cor"]:checked')?.value;
      const selectedSize = root.querySelector('input[type="radio"][data-name="Tamanho"]:checked')?.value;

      const parts = [];
      if (selectedColor) parts.push(`Cor: ${selectedColor}`);
      if (selectedSize) parts.push(`Tamanho: ${selectedSize}`);

      const variantLabel = parts.length ? parts.join(" | ") : undefined;

      // Example: "Entrega prevista para: Cor: Preta | Tamanho: G — Janeiro/2026"
      const deliveryMessage = deliveryText
        ? `${variantLabel ? `• ${variantLabel} — ${deliveryText}` : deliveryText}`
        : (variantLabel ? `${variantLabel}` : undefined);

      window.BackorderDialogs.openPolicyTerms(deliveryMessage, () => {
          productForm.dispatchEvent(new Event("submit"));
      });
    }, {
      signal: this.preOrderAbortControllerForListeners.signal
    })
  }

  if (buttonsWrapper && !buttonsWrapper.querySelector(".pre-order-date-info")) {
    const preOrderSpan = document.createElement("span");
    preOrderSpan.className = "pre-order-date-info";
    preOrderSpan.textContent = ` ${String(preOrderValue ? preOrderValue : preOrderPrazo)}`;
    buttonsWrapper.appendChild(preOrderSpan);
  }
}
async clearPreOrderInfos(scope, hasPreOrder) {
  const root = scope || this.closest("product-info") || this;
  
  // Always abort previous listeners regardless of hasPreOrder state
  this.preOrderAbortControllerForListeners?.abort();
  this.preOrderAbortControllerForListeners = null;
  
  root.querySelectorAll(".pre-order-message-wrapper").forEach((el) => el.remove());
  root.querySelectorAll(".pre-order-date-info").forEach((el) => el.remove());
  root.querySelectorAll(".pre-order-message").forEach((el) => el.remove());
  root.querySelectorAll(".pre-order-tooltip").forEach((el) => el.remove());
  root.querySelectorAll(".pre-order-info").forEach((el) => el.remove());

  const productForm = root.querySelector('product-form') || document.getElementById(`product-form-${this.dataset.section}`);
  const addButton = productForm ? productForm.querySelector('[name="add"]') : null;
  if (addButton) {
    addButton.type = "submit";
    addButton.classList.remove('pre-order-add-button');
    if (window?.variantStrings?.addToCart) {
      addButton.textContent = window.variantStrings.addToCart;
    }
  }
}

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm && typeof productForm.handleErrorMessage === "function") productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);




        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        } else {
          const destinationMobile = document.getElementById(`price-${this.dataset.section}--mobile`);
          const sourceMobile = html.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}--mobile`
          );
          if (sourceMobile && destinationMobile) {
            destinationMobile.innerHTML = sourceMobile.innerHTML;
          }

          const destinationDesktop = document.getElementById(`price-${this.dataset.section}--desktop`);
          const sourceDesktop = html.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}--desktop`
          );
          if (sourceDesktop && destinationDesktop) {
            destinationDesktop.innerHTML = sourceDesktop.innerHTML;
          }
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) {
          price.classList.remove("visibility-hidden");
        } else {
          const priceMobile = document.getElementById(`price-${this.dataset.section}--mobile`);
          if (priceMobile) {
            priceMobile.classList.remove("visibility-hidden");
          }

          const priceDesktop = document.getElementById(`price-${this.dataset.section}--desktop`);
          if (priceDesktop) {
            priceDesktop.classList.remove("visibility-hidden");
          }
        }

        // this.closest(".price-container").remove();

        if (inventoryDestination)
          inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
    
        let isDisabled = addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true;
        let productWithSizeSelected = html.querySelector("variant-radios")
          ? this.querySelector(`variant-radios input[name="Tamanho"]:checked`)
          : null;
        let productWithVariantEnabled = html.querySelector("variant-radios")
          ? html.querySelector(`variant-radios input[name="Tamanho"]:not(.disabled)`)
          : null;
          
          // const discountFlag = this.closest("product-info")?.querySelector("discount-flag");
          // const cupomCountdown = this.closest("product-info")?.querySelector("cupom-countdown");
          // if (discountFlag && cupomCountdown) {
          //   const promotion = JSON.parse(sessionStorage.getItem("insider:cart:promotionCoupon"));
          //   if(promotion && promotion?.discount_config?.type){
          //     discountFlag.updateDiscountFlag(this.currentVariant.compare_at_price, this.currentVariant.price);
          //   }else{
          //     let price = 0;
          //     if(promotion?.data){
          //     price = this.currentVariant.price * (1 - (promotion.data.discount.value * -1) / 100);
          //     }else{
          //       const cupomCountdown = this.closest("product-info")?.querySelector("cupom-countdown");
          //       if (cupomCountdown) {
          //         price = this.currentVariant.price * (1 - parseFloat(cupomCountdown.getAttribute("data-discount")) / 100);
          //       }
          //     }
          //     discountFlag.updateDiscountFlag(this.currentVariant.compare_at_price, price);
          //   }
          // }

        if (!productWithSizeSelected && productWithVariantEnabled) isDisabled = false;

        this.toggleAddButton(isDisabled, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    if (this.currentVariant) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const productInfoParent = addButton.closest("product-info");
      const backInStockBtn = productInfoParent ? productInfoParent.querySelector("#BIS_trigger") : null;
      const backInStockBtnAlce = productInfoParent ? productInfoParent.querySelector("back-in-stock") : null;
      const productInfo = this.closest("product-info");
      const productFormElement = productInfo ? productInfo.querySelector("product-form") : null;
      if (disable) {
        if (productFormElement) productFormElement.classList.add("disabled");
        addButton.setAttribute("disabled", "disabled");
        if (text) addButton.textContent = text;

        this.setUnavailable();

        // TODO: Back In Stock > Será substituído por app da Alce
        if (productInfoParent && backInStockBtn) {
          backInStockBtn.style.display = "flex";
        }

        if (productInfoParent && backInStockBtnAlce) {
          backInStockBtnAlce.style.display = "flex";
          if (backInStockBtnAlce.querySelector("button-wishlist"))
            backInStockBtnAlce.querySelector("button-wishlist").checkIfProductIsInWishlist();
        }
      } else {
        if (productFormElement) productFormElement.classList.remove("disabled");
        addButton.removeAttribute("disabled");
        
        if(!addButton || !addButton.textContent.toLowerCase().includes("Antecipar Compra".toLowerCase())) {
          addButton.textContent = window.variantStrings.addToCart;
        }

        if (productInfoParent && backInStockBtn) {
          backInStockBtn.style.display = "none";
        }

        if (productInfoParent && backInStockBtnAlce) {
          backInStockBtnAlce.style.display = "none";
        }
      }

      if (!modifyClass) return;
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]#variants').textContent);
    let variantMetafields = JSON.parse(document.querySelector('[type="application/json"]#metafields').textContent);
    if(variantMetafields && variantMetafields.length > 0) {
      variantMetafields.forEach((metafield) => {
        const index = this.variantData.findIndex((variant) => {
          return parseInt(variant.id) === parseInt(metafield.variant_id)
        })
        if(index > -1) {
          this.variantData[index].metafield = metafield;
        }
      });
    }
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class VariantCartSelects extends VariantSelects {
  formNode;
  productItemNode;
  variantId
  constructor() {
    super();

    this.optionSelect = "";

    this.productsJson = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.init();
    this.bindImageVariantChange();
    this.bindAddToCartVariantSync();
  }

  init() {
    if (!this.productsJson || !this.productsJson.variants) return;

    this.formNode = document.getElementById(`product-form-${this.dataset.section}-${this.dataset.index}`);
    if (!this.formNode) return;
    this.productItemNode = this.formNode.closest(".products-recommended__item");
    const imageProduct = this.productItemNode.querySelector(".products-recommended__image");
    this.variantId = this.formNode.querySelector(".product-variant-id").value;

    const variant = this.productsJson.variants.filter((product) => product.id == this.variantId);
    let altFirstVariant = variant[0].option1.replace(" ", "-").toLowerCase();

    if (variant[0].option3) {
      altFirstVariant += "-" + variant[0].option3.replace(" ", "-").toLowerCase();
      this.classList.add("has-3-selects"); 
    } else {
      this.classList.add("has-2-selects");
    }

    let altImageVariants = [];

    this.productsJson.media.forEach((media) => {
      if (!media.alt) return;

      let arrayOptions = media.alt.split("|");
      let alt = arrayOptions[0].replace(" ", "-").toLowerCase();
      let altModel = "";

      if (arrayOptions.length > 1) {
        altModel = "-" + arrayOptions[1].replace(" ", "-").toLowerCase();
      }

      let variantFullName = alt + altModel;

      if (altImageVariants.includes(variantFullName)) return;

      altImageVariants.push(variantFullName);

      let image = document.createElement("img");
      image.setAttribute("src", `${media.src}&width=90`);

      image.classList.remove("active");

      if (variantFullName == altFirstVariant) {
        image.classList.add("active");
      } else {
        if (altFirstVariant == alt) {
          image.classList.add("active");
        }
      }
      image.setAttribute("loading", "lazy");
      image.setAttribute("alt", variantFullName);
      image.setAttribute("data-media-alt", variantFullName);

      imageProduct.append(image);
    });

    let nameProduct = this.productsJson.content.toLowerCase();

    if (nameProduct.indexOf("kit") > -1 || this.productsJson.type.toLowerCase() == "kit") {
      this.hideSelectKit();

      let image = document.createElement("img");
      image.setAttribute("src", this.productsJson.media[0].src);
      image.setAttribute("loading", "lazy");
      image.setAttribute("alt", "kit");
      image.setAttribute("data-media-alt", "kit");
      image.classList.add("active");

      imageProduct.append(image);
    } else {
      if (!imageProduct.querySelector("img.active")) {
        const firstTypeSelect = this.querySelectorAll("select")[0];

        if (firstTypeSelect && firstTypeSelect.querySelector(`option[selected="selected"]`)) {
          const firstTypeSelectValue = firstTypeSelect.querySelector(`option[selected="selected"]`).value;

          let alt = firstTypeSelectValue.replace(" ", "-").toLowerCase();

          const img = imageProduct.querySelector("img[data-media-alt='" + alt + "']");

          if (img) img.classList.add("active");
        }
      }
    }
  }

  bindImageVariantChange() {
    this.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => {
        this.updateImageVariant();
      });
    });
  }

  bindAddToCartVariantSync() {
    const syncSelectedVariant = () => {
      this.updateOptions();
      this.updateMasterId();

      if (this.currentVariant) {
        this.updateVariantInput();
      }
    };

    const form = document.getElementById(`product-form-${this.dataset.section}-${this.dataset.index}`);
    if (!form) return;

    const addButton = form.querySelector('[name="add"]');

    form.addEventListener("submit", syncSelectedVariant, { capture: true });
    if (addButton) addButton.addEventListener("click", syncSelectedVariant, { capture: true });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateSelectCount();
    if (this.currentVariant) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
      this.updateImageVariant();
      this.updateVariantInput();
      this.renderProductInfo();
    } else {
      // console.log("Não tem variant");
      this.setOtherProduct();
      this.onVariantChange();
    }
    // this.setPreOrderInfos()
  }

  updateSelectCount() {
    const selects = this.querySelectorAll(".product-form__input--dropdown");
    const actionsWrapper = this.closest(".products-recommended__actions");

    if (actionsWrapper) {
      actionsWrapper.classList.remove("has-2-selects", "has-3-selects");

      if (selects.length === 2) {
        actionsWrapper.classList.add("has-2-selects");
      } else if (selects.length === 3) {
        actionsWrapper.classList.add("has-3-selects");
      }
    }
  }
  // TODO: Remover depois de desinstalar o app de CA
  setPreOrderInfos(){
         const metafieldData = (() => {
        this.variantId = this.formNode.querySelector(".product-variant-id").value;
        const metafieldJsonElement = `[type="application/json"]#metafields, [type="application/json"]#metafields-${this.dataset.index}`
        const variantJsonElement = `[type="application/json"]#variants, [type="application/json"]#variants-${this.dataset.index}`
        let variantData = this.productItemNode.querySelector(variantJsonElement) ? JSON.parse(this.productItemNode.querySelector(variantJsonElement).textContent) : [];
        let variantMetafields = this.productItemNode.querySelector(metafieldJsonElement) ? JSON.parse(this.productItemNode.querySelector(metafieldJsonElement).textContent) : null;
        if(variantMetafields && variantMetafields.length > 0) {
            variantMetafields.forEach((metafield) => {
              const index = variantData.findIndex((variant) => {
                return parseInt(variant.id) === parseInt(metafield.variant_id)
              })
              if(index > -1) {
                variantData[index].metafield = metafield;
              }
            });
          } 
          const variant = variantData.find((v) => parseInt(v.id) === parseInt(this.variantId));
          if (!variant) return null;
          return {
            metafield: variant.metafield || null,
            selling_plan_id: variant.selling_plan_allocations?.[0]?.selling_plan_id || null
          };
      })(); 

        this.querySelectorAll(".pre-order-date").forEach((el) => el.remove());
        const msgbox = this.productItemNode.querySelector(".timer-container-timesact-timer-po");
        const msgCustomModal = document.querySelector("#pre-order-modal-text")?.innerHTML;
        const variantSelectorBtns = this.formNode.querySelector(".product-form__buttons");
    
        if (metafieldData?.metafield) {
            if (msgbox?.classList.contains("hidden")) {
                msgbox.classList.remove("hidden");
            }
            msgbox.querySelector("p").innerHTML = msgCustomModal.replace(
                "[prazo]",
                metafieldData?.metafield?.pre_order.value.toUpperCase()
            );
            let preOrderDate = variantSelectorBtns.querySelector(".pre-order-date");
            if (!preOrderDate) {
                const preOrderDiv = document.createElement("div");
                preOrderDiv.className = "pre-order-tooltip";
                preOrderDate = document.createElement("span");
                preOrderDate.classList.add("pre-order-date");
                preOrderDate.textContent = `Compra Antecipada: Envio a partir de ${metafieldData?.metafield?.pre_order.value.toUpperCase()}`;
                preOrderDiv.appendChild(preOrderDate); 
                variantSelectorBtns.appendChild(preOrderDate);
                this.appendChild(preOrderDate);
                this.formNode.querySelector(".immediate-shipping-info").classList.add("hidden");
                this.formNode.querySelector("button").innerHTML = "+";
            }
    
            preOrderDate.textContent = `Envio a partir de ${metafieldData?.metafield?.pre_order.value.toUpperCase()}`;
            
            // Adiciona o evento ao msgbox apenas uma vez
            if (!msgbox.classList.contains("modal-initialized")) {
                msgbox.addEventListener("click", function (event) {
                    event.preventDefault();
                    const modalBox = document.querySelector(".modal-box__window");
                    modalBox.style.display = "flex";
                    document.body.classList.add("no-scroll");
                });
                msgbox.classList.add("modal-initialized");
            }
        } else {
            if (this.formNode.querySelector(".immediate-shipping-info").classList.contains("hidden")) {
              this.formNode.querySelector(".immediate-shipping-info").classList.remove("hidden");
            }
            if (!msgbox?.classList.contains("hidden")) {
                document.querySelectorAll(".timer-container-timesact-timer-po")?.forEach((_msgbox) => {
                    _msgbox.classList.add("hidden");
                });
            }
            const existingPreOrderDate = variantSelectorBtns?.querySelector(".pre-order-date");
            if (existingPreOrderDate) {
                existingPreOrderDate.parentElement.remove();
                this.formNode.querySelector("button").innerHTML = "+"
                this.formNode.querySelector("button").style.backgroundColor = "#000";
                this.formNode.querySelector("button").style.borderColor = "#000";
            }
        }
  }

  setOtherProduct() {
    if (this.optionSelect == "") {
      this.optionSelect = this.querySelector("select[name='options[Modelo]']") ? "Modelo" : "Tamanho";
    } else {
      if (this.querySelector("select[name='options[Modelo]']")) {
        this.optionSelect = this.optionSelect == "Modelo" ? "Tamanho" : "Modelo";
      }
    }

    this.querySelectorAll(`select[name='options[${this.optionSelect}]'] option`).forEach((option) => {
      option.removeAttribute("selected");
    });

    var element = this.querySelector(`select[name='options[${this.optionSelect}]'] option:not(.not-exist)`);
    element.setAttribute("selected", "selected");

    this.querySelector(`select[name='options[${this.optionSelect}]']`).value = element.value;
  }

  hideSelectKit() {
    const select = this.querySelector("select[name='options[Title]']");
    if (!select) return;
    select.closest(".select").style.display = "none";
  }

  updateImageVariant() {
    const item = this.closest('.products-recommended__item');
    const imageProduct = item?.querySelector('.products-recommended__image');
    if (!imageProduct) return;

    const colorSelect = this.querySelector('select[name="options[Cor]"]');
    const selectedColor = slugify(colorSelect?.value || this.currentVariant?.option1 || '');
    if (!selectedColor) return;

    const activeImage = imageProduct.querySelector(`img[data-media-alt="${selectedColor}"]`);
    if (!activeImage) return;

    imageProduct.querySelectorAll('img.active').forEach((image) => {
      image.classList.remove('active');
    });

    activeImage.classList.add('active');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent).variants;
    return this.variantData;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}-${this.dataset.index}, #product-form-installment-${this.dataset.section}-${this.dataset.index}`
    );

    productForms.forEach((productForm) => {
      const variantInputs = productForm.querySelectorAll('input[name="id"], .product-variant-id');

      variantInputs.forEach((input) => {
        input.value = this.currentVariant.id;
        input.setAttribute("value", this.currentVariant.id);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}-${this.dataset.index}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      if(!addButton || !addButton.textContent.toLowerCase().includes("Antecipar Compra".toLowerCase())) {
        addButton.innerHTML = `
        <span class="product-form__text_add_cart">
          <svg width="64px" height="64px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>plus</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-362.000000, -1037.000000)" fill="#ffffff"> <path d="M390,1049 L382,1049 L382,1041 C382,1038.79 380.209,1037 378,1037 C375.791,1037 374,1038.79 374,1041 L374,1049 L366,1049 C363.791,1049 362,1050.79 362,1053 C362,1055.21 363.791,1057 366,1057 L374,1057 L374,1065 C374,1067.21 375.791,1069 378,1069 C380.209,1069 382,1067.21 382,1065 L382,1057 L390,1057 C392.209,1057 394,1055.21 394,1053 C394,1050.79 392.209,1049 390,1049" id="plus" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
        </span>
        <div class="loading-overlay__spinner hidden">
          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      `;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}-${this.dataset.index}`);
    const addButton = button.querySelector('[name="add"]');

    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions, listOfExistingOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"));
        input.remove()
      }

      if (listOfExistingOptions) {
        if (listOfExistingOptions.includes(input.getAttribute("value"))) {
          input.classList.remove("not-exist");
          input.closest(".variant-option-space").classList.remove("not-exist");
        } else {
          input.classList.add("not-exist");
          input.closest(".variant-option-space").classList.add("not-exist");
        }
      }
    });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    const urlProduct =
      this.dataset.url.indexOf("?") > -1
        ? this.dataset.url + `&variant=${requestedVariantId}&view=smartRecommender`
        : this.dataset.url + `?variant=${requestedVariantId}&view=smartRecommender`;

    fetch(`${urlProduct}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}-${this.dataset.index}`);

        const mediaAlt = this.currentVariant.option1.replace(" ", "-").toLowerCase();

        const infoProduct = html.querySelector("[data-product-info]");
        const source = infoProduct.querySelector("[data-price-element]");

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        const addButtonUpdated = infoProduct.querySelector("[data-product-main-button-buy]");

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );
      });
  }
}
customElements.define("variant-cart-selects", VariantCartSelects);

class VariantRecommendationSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.colorPos = 0;
    this.sizePos = 0;
    this._initialized = false;
  }

  connectedCallback() {
    this.selects = this.querySelectorAll("select");

    // Positions of Color and Size (1-based). Prefer data-* set in HTML; fallback to name inference
    this.colorPos = parseInt(this.dataset.colorPosition || '0');
    this.sizePos = parseInt(this.dataset.sizePosition || '0');

    if (!this.colorPos || !this.sizePos) {
      this.selects.forEach((sel, idx) => {
        const n = (sel.getAttribute('name') || '').toLowerCase();
        const pos = idx + 1; // Liquid positions are 1-based
        if (!this.colorPos && (n.includes('[cor]') || n.includes('[color]') || n.includes('[colour]'))) this.colorPos = pos;
        if (!this.sizePos && (n.includes('[tamanho]') || n.includes('[size]'))) this.sizePos = pos;
      });
    }

    // Use custom variants script id if provided; fallback to #variants
    const variantsId = this.dataset.variantsId || "variants";
    const variantsEl = this.querySelector(`#${variantsId}`);
    this.variantData = variantsEl ? JSON.parse(variantsEl.textContent) : [];

    this.selects.forEach((select) => {
      select.addEventListener("change", (e) => this.onVariantChange(e));
    });

    // Initial cache of options for all selects (in visual order)
    this._initialOptionsPerSelect = Array.from(this.selects).map(sel =>
      Array.from(sel.options).map(o => ({ value: o.value, text: o.textContent }))
    );

    // Initial cache of Size options to preserve order
    if (this.sizePos) {
      const sizeIdx = this.sizePos - 1;
      const sizeSelect = this.selects[sizeIdx];
      if (sizeSelect) {
        this._sizeInitialOptions = Array.from(sizeSelect.options).map(o => ({
          value: o.value,
          text: o.textContent
        }));
      }
    }

    // Ensure product-form.js has the global JSON it expects (#variants/#metafields) right before submit/click
    const formId = `product-form-${this.dataset.section}-${this.dataset.index}`;
    const wrapper = this.closest('.products-recommended-list__item') || this.closest('.products-recommended__item');
    const productForm = document.getElementById(formId) || (wrapper ? wrapper.querySelector(`#${CSS.escape(formId)}`) : null);
    if (productForm) {
      const addButton = productForm.querySelector('button[name="add"]');
      if (addButton) {
        addButton.addEventListener('click', () => this.ensureGlobalVariantPayload(), { capture: true });
      }
      productForm.addEventListener('submit', () => this.ensureGlobalVariantPayload(), { capture: true });
    }

    // Initialize state
    this.onVariantChange();
  }
  // Inject minimal #variants / #metafields expected by product-form.js using this card's JSON
  ensureGlobalVariantPayload() {
    try {
      // Use the local variants JSON inside this custom element
      const localJsonEl = this.querySelector('script[type="application/json"]');
      const variants = localJsonEl ? JSON.parse(localJsonEl.textContent) : [];

      // Ensure global #variants exists with our scoped payload
      let globalVariants = document.querySelector('[type="application/json"]#variants');
      if (!globalVariants) {
        globalVariants = document.createElement('script');
        globalVariants.type = 'application/json';
        globalVariants.id = 'variants';
        document.body.appendChild(globalVariants);
      }
      globalVariants.textContent = JSON.stringify(variants);

      // Ensure global #metafields exists (optional; empty array is fine)
      let globalMetafields = document.querySelector('[type="application/json"]#metafields');
      if (!globalMetafields) {
        globalMetafields = document.createElement('script');
        globalMetafields.type = 'application/json';
        globalMetafields.id = 'metafields';
        document.body.appendChild(globalMetafields);
      }
      if (!globalMetafields.textContent) globalMetafields.textContent = JSON.stringify([]);
    } catch (e) {
      // Do not block submit if something goes wrong
    }
  }

  // normalize strings for safe compare
  normalize(val) {
    return String(val == null ? '' : val).trim().toLowerCase();
  }

  // given currently selected Color, return first available variant for that color
  firstAvailableForColor(colorValue) {
    const colorIdx = Math.max(0, (this.colorPos || 1) - 1);
    const normColor = this.normalize(colorValue);
    return (this.variantData || []).find(v => this.normalize(v.options[colorIdx]) === normColor) || null;
  }

  // return the first available size for the selected color, respecting the visual order of the size select options
  firstAvailableSizeForColor(colorValue) {
    if (!this.sizePos) return null;
    const sizeIdx = this.sizePos - 1;
    const sizeSelect = this.selects[sizeIdx];
    if (!sizeSelect) return null;

    const colorIdx = Math.max(0, (this.colorPos || 1) - 1);
    const availableSizes = (this.variantData || [])
      .filter(v => v.available && this.normalize(v.options[colorIdx]) === this.normalize(colorValue))
      .map(v => v.options[sizeIdx]);

    // pick the first size that both exists in the select and is available for the color
    for (const opt of Array.from(sizeSelect.options)) {
      if (availableSizes.some(sz => this.normalize(sz) === this.normalize(opt.value))) {
        return opt.value;
      }
    }
    return null;
  }

  // set size select safely to a given value (or first option if not found)
  setSizeSafely(nextSizeValue) {
    if (!this.sizePos) return false;
    const sizeIdx = this.sizePos - 1;
    const sizeSelect = this.selects[sizeIdx];
    if (!sizeSelect) return false;

    let finalValue = nextSizeValue;
    const exists = Array.from(sizeSelect.options).some(o => this.normalize(o.value) === this.normalize(nextSizeValue));
    if (!exists) {
      finalValue = sizeSelect.options.length ? sizeSelect.options[0].value : '';
    }

    if (finalValue && sizeSelect.value !== finalValue) {
      sizeSelect.value = finalValue;
      // Trigger change so the component flows normally
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  // Enable/disable the recommender add-to-cart button and toggle its spinner (do not change label)
  toggleAddButton(disable = true) {
    const formId = `product-form-${this.dataset.section}-${this.dataset.index}`;
    const wrapper = this.closest('.products-recommended-list__item') || this.closest('.products-recommended__item');
    const productForm = document.getElementById(formId) || (wrapper ? wrapper.querySelector(`#${CSS.escape(formId)}`) : null);
    if (!productForm) return;

    const addButton = productForm.querySelector('button[name="add"]');
    if (!addButton) return;

    const spinner = addButton.querySelector('.loading-overlay__spinner');
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.setAttribute('aria-busy', 'true');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('aria-busy');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  // Update hidden inputs for the recommender add-to-cart forms
  updateVariantInputs(variantId) {
    const wrapper = this.closest('.products-recommended-list__item') || this.closest('.products-recommended__item');
    const selectors = [
      `#product-form-${this.dataset.section}-${this.dataset.index}`,
      `#product-form-installment-${this.dataset.section}-${this.dataset.index}`
    ];

    selectors.forEach((sel) => {
      const form = document.querySelector(sel) || (wrapper ? wrapper.querySelector(sel) : null);
      if (!form) return;

      // Standard Shopify input used for the submission
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Theme-specific mirror (used in some flows like image or init)
      const mirrorInput = form.querySelector('.product-variant-id');
      if (mirrorInput) {
        mirrorInput.value = variantId;
        mirrorInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Filter the Size select to show only sizes available for the current color
  filterSizeOptionsByColor(selectedColor) {
    if (!this.colorPos || !this.sizePos || !this._sizeInitialOptions) return false;
    const colorIdx = this.colorPos - 1;
    const sizeIdx = this.sizePos - 1;
    const sizeSelect = this.selects[sizeIdx];
    if (!sizeSelect) return false;

    // Set of available sizes for this color
    const availableSizesSet = new Set(
      (this.variantData || [])
        .filter(v => String(v.options[colorIdx]).trim() === String(selectedColor).trim())
        .map(v => v.options[sizeIdx])
    );

    // Rebuild options while preserving initial order
    const newOptions = this._sizeInitialOptions.filter(opt => availableSizesSet.has(opt.value));
    if (newOptions.length === 0) return false;

    sizeSelect.innerHTML = "";
    newOptions.forEach(opt => {
      const optionEl = document.createElement("option");
      optionEl.value = opt.value;
      optionEl.textContent = opt.text;
      sizeSelect.appendChild(optionEl);
    });

    // Reset to the first valid option if necessary
    if (!newOptions.map(o => o.value).includes(sizeSelect.value)) {
      sizeSelect.value = newOptions[0].value;
      sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }
    return false;
  }

  // Return a set of valid values for the select at targetIdx,
  // considering the previous choices in selectedValues (array of strings).
  getAvailableValuesForIndex(targetIdx, selectedValues) {
    const opts = new Set();
    (this.variantData || []).forEach(v => {
      for (let i = 0; i < targetIdx; i++) {
        if (selectedValues[i] == null) return;
        if (String(v.options[i]).trim() !== String(selectedValues[i]).trim()) return;
      }
      opts.add(v.options[targetIdx]);
    });
    return opts;
  }

  // Filter the selects in cascade (from left to right), preserving the initial visual order
  // and ensuring that each select has a valid value selected. If `forceResetFromIndex >= 0`,
  // all selects from that index onward will be **reset to the first available option**.
  // Returns true if any select had its value changed (to re-enter via 'change').
  filterOptionsCascade(forceResetFromIndex = -1) {
    if (!this.selects || this.selects.length === 0) return false;

    const currentValues = Array.from(this.selects).map(s => s.value);

    for (let idx = 0; idx < this.selects.length; idx++) {
      const sel = this.selects[idx];
      const baseList = (this._initialOptionsPerSelect && this._initialOptionsPerSelect[idx])
        ? this._initialOptionsPerSelect[idx]
        : Array.from(sel.options).map(o => ({ value: o.value, text: o.textContent }));

      const allowed = this.getAvailableValuesForIndex(idx, currentValues);
      if (!allowed || allowed.size === 0) continue; // defensive

      const nextOptions = baseList.filter(opt => allowed.has(opt.value));

      // Rebuild if necessary
      const nowValues = Array.from(sel.options).map(o => o.value);
      const desiredValues = nextOptions.map(o => o.value);
      const sameList = nowValues.length === desiredValues.length && nowValues.every((v, i) => v === desiredValues[i]);
      if (!sameList) {
        sel.innerHTML = '';
        nextOptions.forEach(opt => {
          const o = document.createElement('option');
          o.value = opt.value;
          o.textContent = opt.text;
          sel.appendChild(o);
        });
      }

      const mustForceReset = forceResetFromIndex > -1 && idx >= forceResetFromIndex;
      if (mustForceReset) {
        const newVal = desiredValues[0];
        if (sel.value !== newVal) {
          sel.value = newVal;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return true; // will re-enter with consistent state
        }
        currentValues[idx] = sel.value;
        continue;
      }

      // Without force: just ensure the current value is allowed; if not, reset to the first option
      if (!desiredValues.includes(currentValues[idx])) {
        sel.value = desiredValues[0];
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      } else {
        currentValues[idx] = sel.value;
      }
    }

    return false;
  }

  onVariantChange(e) {
    if (!this.variantData || this.variantData.length === 0) return;

    // Determine which select triggered the change (if any)
    const triggeredBy = e && e.target ? e.target : null;
    const sizeIdx = this.sizePos ? this.sizePos - 1 : -1;
    const colorIdx = this.colorPos ? this.colorPos - 1 : -1;

    // Cascade filtering: on first render or whenever any select changes
    // Force reset starting from Size when Color changes (or on first load).
    const firstRun = !this._initialized;
    const colorChanged = triggeredBy && colorIdx > -1 && this.selects[colorIdx] === triggeredBy;
    let forceFrom = -1;

    if ((firstRun || colorChanged) && sizeIdx > -1) {
      forceFrom = sizeIdx; // reset Size (and onward) to the first available option
    } else if (triggeredBy && sizeIdx > -1 && this.selects[sizeIdx] === triggeredBy) {
      // If the user changed Size and there is a 3rd option, force reset of it
      if (this.selects.length > sizeIdx + 1) {
        forceFrom = sizeIdx + 1;
      }
    }
    const changed = this.filterOptionsCascade(forceFrom);
    if (changed) return; // already triggered 'change'; will re-enter with a valid combination
    
    // 2) With filtered selects, grab adjusted options and try to match a variant
    const adjustedOptions = Array.from(this.selects).map((select) => select.value);
    let matchingVariant = this.variantData.find((variant) =>
      variant.options.every((opt, idx) => opt === adjustedOptions[idx])
    );

    // 3) If still no valid combination (should be rare after cascade), keep button disabled
    if (!matchingVariant) {
      this.toggleAddButton(true);
      this._initialized = true;
      return;
    }

    // 4) Update hidden inputs used by the Add-to-cart forms
    this.updateVariantInputs(matchingVariant.id);

    // 5) Button state strictly by availability (label untouched)
    this.toggleAddButton(!matchingVariant.available);

    // 6) Update image (if present)
    const wrapper = this.closest('.products-recommended-list__item') || this.closest('.products-recommended__item');
    const imageElement = wrapper?.querySelector('img');
    if (imageElement && matchingVariant.featured_image) {
      imageElement.src = matchingVariant.featured_image.src;
      imageElement.alt = matchingVariant.featured_image.alt || '';
    }

    // 7) Update price via section render (keeps existing target/fallbacks)
    if (this.dataset.url && this.dataset.section) {
      fetch(`${this.dataset.url}?variant=${matchingVariant.id}&section_id=${this.dataset.section}`)
        .then((res) => res.text())
        .then((html) => {
          const tempDOM = new DOMParser().parseFromString(html, 'text/html');

          const priceTargetId = this.dataset.priceTarget || `price-${this.dataset.section}-recommended-list`;
          const newPrice = tempDOM.querySelector(`#${CSS.escape(priceTargetId)}`);

          const priceDestById = document.getElementById(priceTargetId);
          const fallbackDest = wrapper?.querySelector('.products-recommended-list__price-box');

          if (newPrice && (priceDestById || fallbackDest)) {
            (priceDestById || fallbackDest).innerHTML = newPrice.innerHTML;
          }

          // Re-affirm button state after render (in case availability toggled server-side)
          this.toggleAddButton(!matchingVariant.available);
        })
        .catch(() => {
          // Silent fail; button state already set from client variant data
        });
    } 

    this._initialized = true;
  }
}
customElements.define("variant-recommendation-selects", VariantRecommendationSelects);

let variantsElemetControl = true;
class VariantRadios extends VariantSelects {
  constructor() {
    super();
    if (variantsElemetControl) {
      variantsElemetControl = false;
      this.init();
    }
  }

  init() {
    this.parseHiddenVariants();
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.applyHiddenColors();

    this.reloadVariantsInQuickAdd();
  }

  parseHiddenVariants() {
    const raw = this.dataset.hideSize || "";
    const ids = raw
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    this._hiddenVariantIds = new Set(ids);
    this._hiddenVariantCombos = new Set();
    this._colorsFullyHidden = new Set();

    if (!ids.length) return;

    const variants = this.getVariantData ? this.getVariantData() : [];

    const colorToSizesHidden = new Map();
    const colorToSizesVisible = new Map();

    variants.forEach((v) => {
      const color = v.option1;
      const size = v.option2;
      if (!color || !size) return;

      const idStr = String(v.id);
      if (this._hiddenVariantIds.has(idStr)) {
        // combo cor+tamanho que deve ser ocultado
        this._hiddenVariantCombos.add(`${color}|||${size}`);

        if (!colorToSizesHidden.has(color)) colorToSizesHidden.set(color, new Set());
        colorToSizesHidden.get(color).add(size);
      } else {
        if (!colorToSizesVisible.has(color)) colorToSizesVisible.set(color, new Set());
        colorToSizesVisible.get(color).add(size);
      }
    });

    colorToSizesHidden.forEach((hiddenSet, color) => {
      const visibleSet = colorToSizesVisible.get(color);
      if (hiddenSet.size > 0 && (!visibleSet || visibleSet.size === 0)) {
        this._colorsFullyHidden.add(color);
      }
    });
  }

  applyHiddenColors() {
    if (!this._colorsFullyHidden || this._colorsFullyHidden.size === 0) return;

    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const colorFieldset = fieldsets[0];
    if (!colorFieldset) return;

    const colorInputs = Array.from(colorFieldset.querySelectorAll('input[type="radio"]'));
    let needsReselect = false;

    colorInputs.forEach((input) => {
      const value = input.getAttribute("value");
      if (!this._colorsFullyHidden.has(value)) return;

      const wrapper =
        input.closest(".variant-option-space") ||
        input.closest("label") ||
        input.parentElement;

      if (wrapper) {
        wrapper.style.display = "none";
        wrapper.classList.add("not-exist");
      }

      input.classList.add("not-exist");
      input.disabled = true;
      if (input.checked) {
        input.checked = false;
        needsReselect = true;
      }
    });

    if (needsReselect) {
      const firstAvailable = colorInputs.find((input) => !input.disabled);
      if (firstAvailable) {
        firstAvailable.checked = true;
        firstAvailable.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  reloadVariantsInQuickAdd() {
    if (this.id.indexOf(`quickadd`) > -1) {
      super.variantsCart = true;
      this.onVariantChange();
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions, listOfExistingOptions, sizeSelected = false) {
    const currentColor = Array.isArray(this.options) && this.options.length > 0 ? this.options[0] : null;

    listOfOptions.forEach((input) => {
      const value = input.getAttribute("value");
      const position = input.dataset.position;
      const wrapper = input.closest(".variant-option-space");

      // Respeita lista de opções existentes (estoque/combinações reais)
      if (listOfExistingOptions) {
        if (listOfExistingOptions.includes(value)) {
          input.classList.remove("not-exist");
          if (wrapper) wrapper.classList.remove("not-exist");
        } else {
          input.classList.add("not-exist");
          if (wrapper) wrapper.classList.add("not-exist");
          if (input.checked) {
            input.checked = false;
            setTimeout(() => {
              const firstInputSamePosition =
                this.querySelector(
                  `input[type="radio"][data-position="${input.dataset.position}"]:not(.not-exist)`
                ) ?? false;
              if (firstInputSamePosition) {
                firstInputSamePosition.checked = true;
                // dispatch change event to update the variant
                firstInputSamePosition.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }, 100);
          }
        }
      }

      // Ocultar completamente cores que só têm tamanhos ocultos pela metafield
      if (position === "1" && this._colorsFullyHidden && this._colorsFullyHidden.has(value)) {
        input.classList.add("not-exist");
        input.disabled = true;
        if (wrapper) {
          wrapper.style.display = "none";
          wrapper.classList.add("not-exist");
        }
        if (input.checked) {
          input.checked = false;
          setTimeout(() => {
            const firstVisibleColor =
              this.querySelector(
                'input[type="radio"][data-position="1"]:not(.not-exist):not(:disabled)'
              ) ?? false;
            if (firstVisibleColor) {
              firstVisibleColor.checked = true;
              firstVisibleColor.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }, 0);
        }
        return;
      }

      // Ocultar tamanhos específicos para a cor selecionada
      let isHiddenForColor = false;
      if (
        position === "2" &&
        currentColor &&
        this._hiddenVariantCombos &&
        this._hiddenVariantCombos.size > 0
      ) {
        const key = `${currentColor}|||${value}`;
        if (this._hiddenVariantCombos.has(key)) {
          isHiddenForColor = true;
        }
      }

      if (position === "2" && isHiddenForColor) {
        input.classList.add("disabled");
        if (wrapper) {
          wrapper.style.display = "none";
        }
        if (input.checked) {
          input.checked = false;
        }
        return;
      } else if (position === "2" && wrapper) {
        // Garante que tamanhos não ocultos reapareçam ao trocar de cor
        wrapper.style.removeProperty("display");
      }

      // Lógica original de disponibilidade (estoque)
      if (listOfAvailableOptions.includes(value)) {
        input.classList.remove("disabled");
      } else {
        if (sizeSelected) input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value;
    });

    fieldsets.forEach((fieldset) => {
      const label = fieldset.querySelector(".form__label");
      const productId = fieldset.querySelector("input").getAttribute("data-product-id");
      const plain = label.textContent || "";
      const arrayWord = plain.indexOf(":") > -1 ? plain.split(":") : plain;
      const nameLabel = Array.isArray(arrayWord) ? arrayWord[0] : arrayWord;
      const nameLabelLowerCase = nameLabel.toLowerCase();
      const productIdsDescription = document.querySelectorAll(".variant-ids-add-description-name");
      let productDescriptionText = null;
      
      productIdsDescription.forEach((block) => {
        const productIds = block.getAttribute("data-product-ids")?.split(",") ?? [];
        const variantName = block.getAttribute("data-variant-name");
        const descriptionText = block.getAttribute("data-variant-description");
      
        if (
          this.options[0] === variantName &&
          productIds.includes(productId)
        ) {
          productDescriptionText = descriptionText;
        }
      });
      
      if (
        nameLabelLowerCase.includes("cor") ||
        nameLabelLowerCase.includes("color") ||
        nameLabelLowerCase.includes("colour")
      ) {
        if (productDescriptionText) { 
          label.innerHTML = `<span class='form__label--name'>${nameLabel.trim()}: <span>${this.options[0]}${productDescriptionText}</span></span>`;
        } else {
          label.innerHTML = `<span class='form__label--name'>${nameLabel.trim()}: <span>${this.options[0]}</span></span>`;
        }
      }
    });
  }
}
customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const fethingProductData = () => {
       fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector("glide-component") && this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }


    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fethingProductData()
    };
    
    if(this.classList.contains("complementary-products")) {
      fethingProductData()
    } else {
    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);

    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class FooterElement extends HTMLElement {
  constructor() {
    super();

    this.item =
      document.querySelectorAll(".footer-block__closed--mobile").length > 0
        ? document.querySelectorAll(".footer-block__closed--mobile")
        : null;

    this.init();
  }

  init() {
    if (this.item) {
      this.item.forEach((element) => {
        element.addEventListener("click", this.handleItem.bind(this));
      });
    }
  }

  handleItem(e) {
    let selection =
      Array.from(e.target.classList).find((elements) => elements === "footer-block__closed--mobile") == undefined
        ? e.target.parentElement
        : e.target;

    selection.classList.contains("active") ? selection.classList.remove("active") : selection.classList.add("active");
  }
}
customElements.define("footer-element", FooterElement);

let changePriceRegular;

// TODO: usado para testes
// const getCart = () => {
//   fetch("/cart.js")
//     .then((response) => response.json())
//     .then((data) => {
//       console.log(data);
//     });
// };

(function() {
  const urlParams = new URLSearchParams(window.location.search);

  const cleanCache = urlParams.get('cache') === 'clean';
  const cleanCookies = urlParams.get('cookies') === 'clean';

  if (cleanCache) {
    console.log('Limpando localStorage e sessionStorage...');
    localStorage.clear();
    sessionStorage.clear();
  }

  if (cleanCookies) {
    console.log('Limpando cookies...');
    document.cookie.split(";").forEach(function(c) {
      document.cookie = c.trim().split("=")[0] + 
                        "=;expires=" + new Date(0).toUTCString() + 
                        ";path=/";
    });
  }

  // Opcional: remove os parâmetros e recarrega a página
  if (cleanCache || cleanCookies) {
    const newUrl = window.location.origin + window.location.pathname;
    window.location.replace(newUrl);
  }
})();